import React, { useEffect } from 'react';
import styles from '../css/Declaracion.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const DeclaracionFe = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1200, once: true });
    }, []);

    const articulos = [
        {
            title: "DE LA SANTÍSIMA TRINIDAD",
            img: "/fe_1.jpg",
            text: "Hay un solo Dios, vivo y verdadero, eterno, de infinito poder, sabiduría y bondad, creador y conservador de todas las cosas, así visibles como invisibles. Y en la unidad de ésta, hay tres personas y cada una de ellas es Dios y manifestación plena de la Naturaleza Divina: El Padre, El Hijo y El Espíritu Santo.",
        },
        {
            title: "DEL VERBO QUE FUE HECHO HOMBRE",
            text: "El Hijo, que es Verbo del Padre, verdadero y eterno Dios, de una misma substancia con el Padre, tomó la naturaleza humana en el seno de la bienaventurada virgen, de manera que dos naturalezas, a saber: La Divina y la Humana, se unieron en una sola persona, para jamás ser separadas.",
        },
        {
            title: "DEL ESPÍRITU SANTO",
            img: "/fe_2.jpg",
            text: "El Espíritu Santo, que procede del Padre y del Hijo, es de una misma substancia, majestad y gloria con el Padre y con el Hijo, verdadero y eterno Dios. Es quien consuela, guía y santifica a la iglesia de Cristo.",
        },
        {
            title: "SUFICIENCIA DE LAS ESCRITURAS",
            text: "La Santa Biblia contiene todas las cosas necesarias para la salvación, de modo que no debe exigirse que hombre alguno reciba como artículo de fe nada que en ellas no se lea, ni pueda por ellas probarse.",
        },
        {
            title: "SACRAMENTOS Y BAUTISMO",
            img: "/fe_3.jpg",
            text: "La Iglesia practica la Santa Cena del Señor y El Bautismo. El bautismo será administrado por aspersión a los infantes y adultos, en el nombre del Padre, del Hijo, y del Espíritu Santo como señal de profesión y signo de regeneración.",
        }
    ];

    return (
        <div className={styles.container}>
            {/* 1. SECCIÓN HERO (TÍTULO E IMAGEN DE FONDO) */}
            <section 
                className={styles.hero}
                style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.6)), url('/historia_profecia.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed'
                }}
            >
                <div className={styles.heroContent} data-aos="fade-down">
                    <span className={styles.preTitle}>Doctrina y Fundamento</span>
                    <h1 className={styles.mainTitle}>Nuestra Fe</h1>
                    <div className={styles.goldDivider}></div>
                    <p className={styles.quote}>"Un solo Señor, una sola fe, un solo bautismo"</p>
                </div>
            </section>

            {/* 2. CONTENIDO PRINCIPAL */}
            <main className={styles.content}>
                {/* Intro sutil */}
                <div className={styles.introCard} data-aos="fade-up">
                    <p>Principios y artículos de fe que guían nuestro caminar en la <strong>IGLESIA UNIDA METODISTA PENTECOSTAL</strong>.</p>
                </div>

                <div className={styles.articulosGrid}>
                    {articulos.map((art, index) => (
                        <section key={index} className={styles.sectionCard} data-aos="fade-up">
                            <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <span className={styles.number}>{index + 1}</span>
                                    <h2>{art.title}</h2>
                                </div>
                                <div className={styles.cardBody}>
                                    {art.img && (
                                        <div className={styles.imageContainer}>
                                            <img src={art.img} alt={art.title} className={styles.artImage} />
                                        </div>
                                    )}
                                    <p>{art.text}</p>
                                </div>
                            </div>
                        </section>
                    ))}
                </div>
            </main>
        </div>
    );
};

export default DeclaracionFe;